// auth.js

// import AsyncStorage from "@react-native-async-storage/async-storage";
import { Platform } from "react-native";
import cookie from "components/helpers/cookie";
import { api, axios } from "components/helpers/api";

const auth = (main) => {
  // Prevent multiple reloads.
  if (!!main.auth) {
    return main.auth;
  }
  if (!main.lib) {
    throw new Error("Missing required parameter `main.lib` main library.");
  }
  main.api = api;
  main.axios = axios;
  const authMethods = {};
  authMethods.cookieName = "access_token";

  // main.lib.getStore = async (name) => {
  //   try {
  //     return await AsyncStorage.getItem(name);
  //   } catch (err) {
  //     return err;
  //   }
  // };

  // main.lib.setStore = async (name, val) => {
  //   try {
  //     return await AsyncStorage.setItem(name, val);
  //   } catch (err) {
  //     return err;
  //   }
  // };

  const _checkSession = async (forceCheckApi, forceRepaint) => {
    const _isLoggedin = main.lib.getIsLoggedin();  // from Main.js useState bool flag.
    if ((!_isLoggedin || !!forceCheckApi)) {
      try {
        const resp = await axios.get(main.api.session);
        if (resp?.code==="ERR_NETWORK" || resp?.code==="ECONNABORTED") {
          if (main.lib.getCurrentView()!=="offline") {
            main.lib.setTempCurrentView("offline");
            main.lib.setIsSessionChecked(true);
          } else {
            main.lib.setIsSessionChecked(true);
          }
          main.lib.setAppState([
            {key:"initReady",			  type:"boolean",	initReady: true},
            {key:"isScreenLoading",	type:"boolean",	isScreenLoading: false},
          ]);
          return false;
        } else if (Number(resp?.status)>=400) {
          main.lib.setIsSessionChecked(true);
          main.lib.setAppState([
            {key:"initReady",			  type:"boolean",	initReady: true},
            {key:"isScreenLoading",	type:"boolean",	isScreenLoading: false},
          ]);
          return false;
        }
        const _apiLoggedin = !!Number(resp?.data?.staff_id);
        const _isFirstCheck = !main.lib.getIsSessionChecked();
        if (_apiLoggedin !== _isLoggedin || !!forceRepaint) {
          main.lib.setUserProfile(resp?.data || {});
          main.lib.setTempIsLoggedin(_apiLoggedin);
          main.lib.setIsSessionChecked(true);
          if (!!forceRepaint && (_isLoggedin !== _apiLoggedin || _isFirstCheck)) {
            main.lib.triggerMainState();
          }
        }
        main.lib.setAppState([
          {key:"initReady",			  type:"boolean",	initReady: true},
          {key:"isScreenLoading",	type:"boolean",	isScreenLoading: false},
        ]);
        // Make sure client cookie exists for user local timezone offset.
        // const _cookies = cookie.getAll();
        // console.log("_cookies =", _cookies);
        // if (!_cookies.tzo) {
        //   cookie.set("tzo",((new Date()).getTimezoneOffset()/60));
        // }
        return true;
      } catch (err) {
        console.log("Check-Session Error:", JSON.stringify(err));
        const __apiLoggedin = false;
        const __isFirstCheck = !main.lib.getIsSessionChecked();

        if (__apiLoggedin !== _isLoggedin || !!forceRepaint) {
          main.lib.setUserProfile({});
          main.lib.setTempIsLoggedin(__apiLoggedin);
          main.lib.setTempIsSessionChecked(true);

          if (!!forceRepaint || __isFirstCheck) {
            main.lib.triggerMainState();
          }
        }

        main.lib.setAppState([
          { key: "initReady", type: "boolean", initReady: true },
          { key: "isScreenLoading", type: "boolean", isScreenLoading: false },
        ]);

        return false;
      }

    } else {
      if (!!forceRepaint) {
        main.lib.triggerMainState();
      }
      return true;
    }
  };

  // Now this one can be called without `await` because it's a proxy with it's own await inside.
  authMethods.checkSession = async (forceCheckApi, forceRepaint) => {
    const result = await _checkSession(forceCheckApi, forceRepaint);
    return (!!result);
  };

  authMethods.setSession = (token) => {
    if (!!token && typeof(token) !== "string") {
      token = JSON.stringify(token);
    }
    const sessionExpiry = (1000*60*60*24 * 7);  // 7 days in milliseconds
    if (!!token) {
      // YES TOKEN
      if (Platform.OS === "web") {
        // WEB: THIS WAS AUTO-SET FROM THE AJAX AUTH API CALL!
        // NOTHING TO DO HERE.
      } else {
        // MOBILE: Currently not using anything in mobile, it's working natively as well.
        // Mobile will need to set storage, and pull from storage to replace cookie sent to API on every request to prevent bugs on mobile.
        // AsyncStorage.setItem(authMethods.cookieName, token, { expire: sessionExpiry });
      }
      // Make sure client cookie exists for user local timezone offset.
      // const _cookies = cookie.getAll();
      // console.log("_cookies =", _cookies);
      // if (!_cookies.tzo) {
      //   cookie.set("tzo",((new Date()).getTimezoneOffset()/60));
      // }
    } else {
      // NO TOKEN
      // if (Platform.OS === "web") {
      //   // This doesn't work:
      //   // Cookie.set(authMethods.cookieName, "null", cookieConfig);
      //   // Try manual old fashion way:
      //   document.cookie = `${authMethods.cookieName}=null; expires=-99999; path=/; domain=${main.api.cookie_____Domain}`;
      // } else {
      //   // AsyncStorage.removeItem(authMethods.cookieName);
      // }
      cookie.clearAll();
      main.lib.setIsLoggedin(false);
    }
    return true;
  };

  return authMethods;
};

export default auth;